module.exports = __webpack_public_path__ + "img/reject.035bf0a6.svg";